import { AmplitudeEvent } from "./AmplitudeEvent";

const TYPE_TO_VALUE_MAP = {
	ALL_MEETINGS: "All meetings",
	TEAM_MEETINGS: "Team meetings",
	ONE_ON_ONE_MEETINGS: "1:1 meetings",
	MEETINGS_WITH_NO_TOPICS: "No topics",
	MEETINGS_WITH_NO_TEAM: "No Team or 1:1",
};

export class ScheduleFilterAppliedEvent extends AmplitudeEvent {
	constructor( value ) {
		super();
		this.name = "Schedule Filter Applied";
		this.eventProperties.selected_filter = TYPE_TO_VALUE_MAP[ value ];
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/ScheduleFilterAppliedEvent.js